import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LandingPage from '../views/LandingPage.vue';
import HomePage from '../views/HomePage.vue';
import UserPage from '../views/UserPage.vue';
import SettingsPage from '../views/SettingsPage.vue';
import { Session } from '@supabase/supabase-js';
import { supabase } from "../lib/supabase";
import { useAuthStore } from "../stores/auth";
import SuccessPage from '@/views/SuccessPage.vue';
import ConfirmEmail from '@/components/ConfirmEmail.vue';
import PricingPage from '@/views/PricingPage.vue';
import ColoringPage from '@/views/ColoringPage.vue';


const routes: Array<RouteRecordRaw> = [
    {
      path: "/",
      component: LandingPage,
    },
    {
      path: "/home",
      component: HomePage,
    },
    {
      path: "/user",
      component: UserPage,
    },
    {
      path: "/settings",
      component: SettingsPage,
    },
    {
      path: "/success",
      component: SuccessPage
    },
    {
      path: "/confirm",
      component: ConfirmEmail
    },
    {
      path: "/pricing",
      component: PricingPage
    },
    {
      path: "/coloring",
      name: 'ColoringPage',
      component: ColoringPage
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _, next) => {
  const authStore = useAuthStore();
  let session: Session | null = null;  
  await supabase.auth.getSession().then(({ data }) => {
    session = data.session;
    authStore.setSession(session);
  });

  if (to.meta.requiresAuth && !session) {
    next("/");
    return;
  }


  if (to.path === '/success') {
    console.log("we were in success")

    const checkoutId = to.query.checkout_id;
    console.log("this is log", checkoutId)

    if (!checkoutId) {
      // next('/');
      return;
    }
    
    // try {
    //   const checkoutData = JSON.parse(polarCheckout);
    //   const timeDiff = Date.now() - checkoutData.timestamp; 
      
      // if (timeDiff > 1 * 60 * 1000) { 
      //   sessionStorage.removeItem('polar_checkout_completed');
      //   next('/');
      //   return;
      // }
      
      // sessionStorage.removeItem('polar_checkout_completed');
      // next();
      // return;
      
    // } catch (error) {
    //   sessionStorage.removeItem('polar_checkout_completed');
      next();
      return;
    }
  
  next();
});

export default router;

